// **React Imports
import { memo, useCallback } from 'react'

// **MUI Imports
import { Button } from '@mui/material'

// **Component Imports
import Icon from '../icon'

// **Utils Imports
import { v4 } from 'uuid'
import { ENVIRONMENT, LINKEDIN_CLIENT_ID } from '../../env/env'
import { DOMAIN } from '../../utils/constant'
import { setCookie } from '../../utils/utils'

const LinkedinVerifyButton = ({
  size = 'small',
  variant = 'contained',
  sx = {},
  className = '',
  children = 'Verify Linkedin Profile',
  iconStyle = {}
}) => {
  // handlers
  const handleLoginWithLinkedin = useCallback(() => {
    const linkedinState = v4()

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: LINKEDIN_CLIENT_ID,
      redirect_uri: `${window.location.hostname === 'localhost' ? window.location.origin : ENVIRONMENT === 'DEV' ? 'https://dev.coderscout.io' : 'https://app.coderscout.io'}/auth/linkedin/callback`,
      state: linkedinState,
      scope: 'openid profile email'
    })

    const cookieConfig = {
      path: '/',
      domain:
        window.location.hostname === 'localhost'
          ? window.location.hostname
          : `.${DOMAIN}`,
      secure: window.location.origin.startsWith('https'),
      sameSite: 'Lax',
      maxAge: 5
    }

    setCookie('redirect-url', window.location.pathname, cookieConfig)
    setCookie('linkedin-auth-state', linkedinState, cookieConfig)

    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`
    window.location.href = linkedInAuthUrl
  }, [])

  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleLoginWithLinkedin}
      className={className}
      startIcon={
        <Icon
          icon={'mdi:linkedin'}
          style={{ fontSize: '1.5rem', color: '#fff', ...iconStyle }}
        />
      }
      sx={{
        backgroundColor: '#0A66C2',
        color: '#fff',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#004182'
        },
        ...sx
      }}
    >
      {children}
    </Button>
  )
}

export default memo(LinkedinVerifyButton)
